import produce from 'immer'
import React, { FC, useEffect, useState } from 'react'
import { Col, Form, Modal, Row } from 'react-bootstrap'
import { FilterOptionModel } from '../../models/utils/filterOption'
import {
  programeTypes,
  Schemeption,
  schemesList,
  status,
} from '../../utils/metaData'
import FilterButton from '../common/filterButton/FilterButton'
import Select from 'react-select'
import IncidentTypesServices from '../../services/systemConfiguration/incidentTypes/incidentTypesServices'
import { CommonTypeOption } from '../../models/selectOptionModels/commonOptionType'
import CompensationValuesServices from '../../services/systemConfiguration/compensationValues/compensationValuesServices'

export interface FileAllocationFiltersProps {
  filterData: FilterOptionModel[]
  onFilter: any
}

const CompensationValuesFilters: FC<FileAllocationFiltersProps> = ({
  filterData,
  onFilter,
}) => {
  const [filters, setFilters] = useState(filterData)
  const [show, setShow] = useState(false)
  const options: CommonTypeOption[] = []
  const [incidentTypesList, setIncidentTypesList] = useState(options)
  const [compensationForList, setCompensationForList] = useState(options)

  useEffect(() => {
    setFilters(filterData)
    async function getMetaData() {
      const incidentData =
        await IncidentTypesServices.apiGetAllIncidentTypesList()
      setIncidentTypesList(incidentData.data)
      const incidentTypeList: CommonTypeOption[] = []
      for (let i = 0; i < incidentData.data.length; i++) {
        const incidentTypeObject: CommonTypeOption = {
          value: incidentData.data[i].id,
          label: incidentData.data[i].incidentType,
        }
        incidentTypeList.push(incidentTypeObject)
      }
      setIncidentTypesList(incidentTypeList)
    }
    getMetaData()
  }, [show])
  const handleCompensationFor = async (value: string) => {
    const compensationFor =
      await CompensationValuesServices.getCompensationForListByScheme(value)
    const compensationValueList: CommonTypeOption[] = []
    for (let i = 0; i < compensationFor.data.length; i++) {
      const compensationValueObject: CommonTypeOption = {
        value: compensationFor.data[i].name,
        label: compensationFor.data[i].name,
      }
      compensationValueList.push(compensationValueObject)
    }
    setCompensationForList(compensationValueList)
  }
  return (
    <>
      <FilterButton
        onClick={() => {
          setShow(true)
        }}
      />
      <Modal
        size="lg"
        show={show}
        onHide={() => {
          setShow(false)
        }}
        aria-labelledby="example-modal-sizes-title-sm"
        dialogClassName="custom-modal-layout"
        contentClassName="custom-modal-content"
      >
        <Modal.Header
          closeButton
          closeVariant="white"
          className="custom-modal-header"
        >
          <Modal.Title id="example-modal-sizes-title-sm">{`Filter`}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="p-4">
            {filters.length > 0 && (
              <Form>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formProgrameType"
                >
                  <Col sm="1" className="align-self-center">
                    <Form.Check
                      type="checkbox"
                      checked={filters[0].selected}
                      onChange={(e) => {
                        const newFilters = produce(
                          filters,
                          (draft: FilterOptionModel[]) => {
                            draft[0].selected = e.target.checked
                          }
                        )
                        setFilters(newFilters)
                      }}
                    />
                  </Col>
                  <Form.Label column sm="5">
                    {`Programe Type`}
                  </Form.Label>
                  <Col sm="6">
                    <Select
                      value={filters[0].dropdownValue}
                      isDisabled={!filters[0].selected}
                      options={programeTypes}
                      onChange={(selectedOption) => {
                        const newFilters = produce(
                          filters,
                          (draft: FilterOptionModel[]) => {
                            draft[0].value = selectedOption?.value
                            draft[0].dropdownValue = selectedOption
                          }
                        )
                        setFilters(newFilters)
                      }}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3" controlId="formScheme">
                  <Col sm="1" className="align-self-center">
                    <Form.Check
                      type="checkbox"
                      checked={filters[1].selected}
                      onChange={(e) => {
                        const newFilters = produce(
                          filters,
                          (draft: FilterOptionModel[]) => {
                            draft[1].selected = e.target.checked
                          }
                        )
                        setFilters(newFilters)
                      }}
                    />
                  </Col>
                  <Form.Label column sm="5">
                    {`Scheme`}
                  </Form.Label>
                  <Col sm="6">
                    <Select
                      value={filters[1].dropdownValue}
                      isDisabled={!filters[1].selected}
                      options={schemesList.filter((scheme: Schemeption) => {
                        return scheme.programeType === filters[0].value
                      })}
                      onChange={(selectedOption) => {
                        handleCompensationFor(selectedOption.value)

                        const newFilters = produce(
                          filters,
                          (draft: FilterOptionModel[]) => {
                            draft[1].value = selectedOption?.value
                            draft[1].dropdownValue = selectedOption
                          }
                        )
                        setFilters(newFilters)
                      }}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3" controlId="incidentType">
                  <Col sm="1" className="align-self-center">
                    <Form.Check
                      type="checkbox"
                      checked={filters[2].selected}
                      onChange={(e) => {
                        const newFilters = produce(
                          filters,
                          (draft: FilterOptionModel[]) => {
                            draft[2].selected = e.target.checked
                          }
                        )
                        setFilters(newFilters)
                      }}
                    />
                  </Col>
                  <Form.Label column sm="5">
                    {`Incident Type`}
                  </Form.Label>
                  <Col sm="6">
                    <Select
                      value={filters[2].dropdownValue}
                      isDisabled={!filters[2].selected}
                      options={incidentTypesList}
                      onChange={(selectedOption) => {
                        const newFilters = produce(
                          filters,
                          (draft: FilterOptionModel[]) => {
                            draft[2].value = selectedOption?.value
                            draft[2].dropdownValue = selectedOption
                          }
                        )
                        setFilters(newFilters)
                      }}
                    />
                  </Col>
                </Form.Group>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="compensationFor"
                >
                  <Col sm="1" className="align-self-center">
                    <Form.Check
                      type="checkbox"
                      checked={filters[3].selected}
                      onChange={(e) => {
                        const newFilters = produce(
                          filters,
                          (draft: FilterOptionModel[]) => {
                            draft[3].selected = e.target.checked
                          }
                        )
                        setFilters(newFilters)
                      }}
                    />
                  </Col>
                  <Form.Label column sm="5">
                    {`Compensation for`}
                  </Form.Label>
                  <Col sm="6">
                    <Select
                      value={filters[3].dropdownValue}
                      isDisabled={!filters[3].selected}
                      options={compensationForList}
                      onChange={(selectedOption) => {
                        const newFilters = produce(
                          filters,
                          (draft: FilterOptionModel[]) => {
                            draft[3].value = selectedOption?.value
                            draft[3].dropdownValue = selectedOption
                          }
                        )
                        setFilters(newFilters)
                      }}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3" controlId="status">
                  <Col sm="1" className="align-self-center">
                    <Form.Check
                      type="checkbox"
                      checked={filters[4].selected}
                      onChange={(e) => {
                        const newFilters = produce(
                          filters,
                          (draft: FilterOptionModel[]) => {
                            draft[4].selected = e.target.checked
                          }
                        )
                        setFilters(newFilters)
                      }}
                    />
                  </Col>
                  <Form.Label column sm="5">
                    {`Status`}
                  </Form.Label>
                  <Col sm="6">
                    <Select
                      value={filters[4].dropdownValue}
                      isDisabled={!filters[4].selected}
                      options={status}
                      onChange={(selectedOption) => {
                        const newFilters = produce(
                          filters,
                          (draft: FilterOptionModel[]) => {
                            draft[4].value = selectedOption?.value
                            draft[4].dropdownValue = selectedOption
                          }
                        )
                        setFilters(newFilters)
                      }}
                    />
                  </Col>
                </Form.Group>
              </Form>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="save-button"
            onClick={() => {
              onFilter(filters)
              setShow(false)
            }}
          >
            Filter Results
          </button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default CompensationValuesFilters
